/*
 * jQuery accessible simple (non-modal) tooltip window, using ARIA
 * @version v2.2.0
 * Website: https://a11y.nicolas-hoffmann.net/simple-tooltip/
 * License MIT: https://github.com/nico3333fr/jquery-accessible-simple-tooltip-aria/blob/master/LICENSE
 */

function accessibleSimpleTooltipAria(options) {
    var element = $(this);
    options = options || element.data();
    var text = options.simpletooltipText || '';
    var prefix_class = typeof options.simpletooltipPrefixClass !== 'undefined' ? options.simpletooltipPrefixClass + '-' : '';
    var content_id = typeof options.simpletooltipContentId !== 'undefined' ? '#' + options.simpletooltipContentId : '';

    var index_lisible = Math.random().toString(32).slice(2, 12);
    var aria_describedby = element.attr('aria-describedby') || '';

    element.attr({
        'aria-describedby': ('label_simpletooltip_' + index_lisible + ' ' + aria_describedby).trim()
    });

    element.wrap('<span class="' + prefix_class + 'simpletooltip_container"></span>');

    var html = '<span class="js-simpletooltip ' + prefix_class + 'simpletooltip" id="label_simpletooltip_' + index_lisible + '" role="tooltip" aria-hidden="true">';

    if (text !== '') {
        html += '' + text + '';
    } else {
        var $contentId = $(content_id);
        if (content_id !== '' && $contentId.length) {
            html += $contentId.html();
        }
    }
    html += '</span>';

    $(html).insertAfter(element);
}

// Bind as a jQuery plugin
// $.fn.accessibleSimpleTooltipAria = accessibleSimpleTooltipAria;

$(document).ready(function() {

    // BOOTSTRAP TOOLTIPS
    // showToolTip Title Attribute müssen auch in den data-title geschrieben werden, damit wir direkt auf der Merkzettel Seite die ToolTips wieder generieren können

    if ($(".showToolTip").length) {

        $(".showToolTip").each(function() {
            $(this).attr("data-title", $(this).attr("title"));
        });

        $("body").tooltip({
            selector: '.showToolTip',
            html: true
        });

    } // if

    // ToolTips für TOURDATA-Detailseiten-Icons
    $('.ttgToolTipIcon').tooltip();

    // END BOOTSTRAP TOOLTIPS

    $('.js-tooltip').each(function() {
        // Call the function with this as the current tooltip
        accessibleSimpleTooltipAria.apply(this);
    });

    // events ------------------
    $('body')
        .on('mouseenter focusin', '.js-tooltip', function() {
            var $this = $(this);
            var aria_describedby = $this.attr('aria-describedby');
            var $tooltip_to_show = $('#' + aria_describedby);
            $tooltip_to_show.attr('aria-hidden', 'false');
        })
        .on('mouseleave', '.js-tooltip', function(event) {
            var $this = $(this);
            var aria_describedby = $this.attr('aria-describedby');
            var $tooltip_to_show = $('#' + aria_describedby);
            var $is_target_hovered = $tooltip_to_show.hasClass('hover');

            if (!$is_target_hovered) {
                $tooltip_to_show.attr('aria-hidden', 'true');
            }
        })
        .on('focusout', '.js-tooltip', function(event) {
            var $this = $(this);
            var aria_describedby = $this.attr('aria-describedby');
            var $tooltip_to_show = $('#' + aria_describedby);

            $tooltip_to_show.attr('aria-hidden', 'true');
        })
        .on('mouseleave', '.js-tooltip', function() {
            var $this = $(this);
            $this.attr('aria-hidden', 'true');
        })
        .on('keydown', '.js-tooltip', function(event) {
            // close esc key
            var $this = $(this);
            var aria_describedby = $this.attr('aria-describedby');
            var $tooltip_to_show = $('#' + aria_describedby);

            if (event.keyCode == 27) { // esc
                $tooltip_to_show.attr('aria-hidden', 'true');
            }
        })
        .on('click', '.js-tooltip', function(event) {
            // close esc key
            var $this = $(this);
            var aria_describedby = $this.attr('aria-describedby');
            var $tooltip_to_show = $('#' + aria_describedby);

            if ($tooltip_to_show.attr("aria-hidden") == "false" && $tooltip_to_show.hasClass('clicked')) {
                $tooltip_to_show.attr('aria-hidden', 'true');
                $tooltip_to_show.toggleClass('clicked');
            } else {
                $tooltip_to_show.attr('aria-hidden', 'false');
                $tooltip_to_show.toggleClass('clicked');
            }
        })
        .on('mouseenter focusin', '.js-simpletooltip', function() {
            var $tooltip_to_show = $(this);
            $tooltip_to_show.toggleClass('hover');
            $tooltip_to_show.attr('aria-hidden', 'false');
        })
        .on('mouseleave', '.js-simpletooltip', function(event) {
            var $tooltip_to_show = $(this);
            $tooltip_to_show.toggleClass('hover');
            $tooltip_to_show.attr('aria-hidden', 'true');
        });
});
